export const moveBackInPathname = (location: string, steps: number) => {
  const locationArray = location.split("/");
  return locationArray.slice(0, locationArray.length - steps).join("/");
};
